import LvRadioGroup from './RadioGroup.vue';
export default LvRadioGroup;
